var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92154 0.748291C4.53671 0.748291 3.20859 1.29841 2.22936 2.27764C1.25014 3.25687 0.700012 4.58499 0.700012 5.96982C0.700012 7.35466 1.25014 8.68277 2.22936 9.662C3.20859 10.6412 4.53671 11.1914 5.92154 11.1914C7.0539 11.1914 8.14833 10.8235 9.04511 10.1541L12.0208 13.1302C12.3137 13.4231 12.7885 13.4231 13.0814 13.1302C13.3744 12.8374 13.3744 12.3625 13.0815 12.0696L10.1058 9.09341C10.7753 8.19663 11.1431 7.10219 11.1431 5.96982C11.1431 4.58499 10.5929 3.25687 9.61372 2.27764C8.6345 1.29841 7.30638 0.748291 5.92154 0.748291ZM8.56801 8.58631C9.25658 7.88986 9.64307 6.94977 9.64307 5.96982C9.64307 4.98281 9.25098 4.03622 8.55306 3.3383C7.85514 2.64038 6.90855 2.24829 5.92154 2.24829C4.93453 2.24829 3.98795 2.64038 3.29002 3.3383C2.5921 4.03622 2.20001 4.98281 2.20001 5.96982C2.20001 6.95683 2.5921 7.90342 3.29002 8.60134C3.98795 9.29926 4.93453 9.69135 5.92154 9.69135C6.90151 9.69135 7.84162 9.30484 8.53807 8.61624C8.54292 8.61112 8.54785 8.60605 8.55287 8.60103C8.55787 8.59604 8.56291 8.59113 8.56801 8.58631Z",
    fill: "#676879"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c06f2a37810ec0ae104d1ff2a6402151.svg";
export { ForwardRef as ReactComponent };